import { render, staticRenderFns } from "./DodatnaAktivnostCreate.vue?vue&type=template&id=5cc1f3d9&scoped=true&"
import script from "./DodatnaAktivnostCreate.vue?vue&type=script&lang=js&"
export * from "./DodatnaAktivnostCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc1f3d9",
  null
  
)

export default component.exports